<template>
  <div>
    <b-card v-if="isAdmin" title="Admin Settings" class="mb-4 bg-light">
      <b-form-row>
        <b-col md="2">
          <b-form-group
            label="Fee"
            description="Markup Margin">
            <b-input-group append="%">
              <b-form-input
                type="number"
                v-model="publisher.fee_indirect"
                :disabled="!isAdmin">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--
        <b-col md="3">
          <b-form-group
            label="Direct Fee"
            description="Revenue share fee per direct billing relationships">
            <b-input-group append="%">
              <b-form-input
                type="number"
                v-model="publisher.fee_direct"
                :disabled="!isAdmin">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            label="Auto Throttle Reqs">
            <toggle-button
              v-model="publisher.auto_throttle"
              :sync="true"
              color="#2bd879">
            </toggle-button>
          </b-form-group>
        </b-col>
        -->
        <b-col md="2">
          <b-form-group
            label="Only Store Reqs w/ Bids">
            <toggle-button
              v-model="publisher.store_only_bids"
              :sync="true"
              color="#2bd879">
            </toggle-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group
            label="Advertible">
            <toggle-button
              v-model="publisher.advertible"
              :sync="true"
              color="#2bd879">
            </toggle-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group
            label="Optimize Floors">
            <toggle-button
              :disabled="!isSuperAdmin"
              v-model="publisher.optimize_floors"
              :sync="true"
              color="#2bd879">
            </toggle-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group
            label="X-15 Proxy">
            <b-form-input
              :disabled="!isSuperAdmin"
              type="number"
              v-model="publisher.x15_proxy_fraction">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col md="2">
          <b-form-group
            label="Send BURL">
            <toggle-button
              v-model="publisher.auction_burl"
              :sync="true"
              color="#2bd879">
            </toggle-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group
            label="ADM Beacon">
            <toggle-button
              v-model="publisher.auction_win_beacon"
              :sync="true"
              color="#2bd879">
            </toggle-button>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            :label="publisher.enabled ? 'Enabled' : 'Disabled'">
            <toggle-button
              v-model="publisher.enabled"
              :color="{ checked: '#2bd879', unchecked: '#F1516C' }"
              :sync="true">
            </toggle-button>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-form-group class="w-100" label="Global hard bundle or pub.id black list"
                      description="Any request with a matching pub id or bundle will be blocked. Expected one value on each line.">
          <newline-editor v-model="publisher.req_id_blacklist" />
        </b-form-group>
      </b-form-row>
    </b-card>

    <b-card title="Demand Filters" class="mb-3">
      <b-form-row>
        <b-col md="3">
          <b-form-group label="Clear Adomains" v-if="publisher.blocked_adomains && publisher.blocked_adomains.length">
            <b-btn class="btn-sm mt-1"
                   @click="publisher.blocked_adomains = []">Clear</b-btn>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col md="12">
          <b-form-group label="List of blocked advertiser domains">
            <string-list-editor :values="publisher.blocked_adomains"
                                placeholder="Enter advertiser domain"></string-list-editor>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col md="3">
          <b-form-group label="Clear IDs" v-if="publisher.blocked_crids && publisher.blocked_crids.length">
            <b-btn class="btn-sm mt-1"
                   @click="publisher.blocked_crids = []">Clear</b-btn>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col md="12">
          <b-form-group label="List of blocked creative IDs">
            <string-list-editor :values="publisher.blocked_crids"
                                placeholder="Enter advertiser creative ID"></string-list-editor>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-card>

    <b-card :title="status === 'loaded' ? publisher.name + ' Settings' : 'New Publisher Profile'">
      <b-form>
        <b-form-row>
          <b-col md="6">
            <b-form-group
              label="Publisher Name"
              description="Name of content company">
              <b-form-input
                type="text"
                v-model="publisher.name"
                required
                placeholder="Great News, Co">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Domain"
              description="Web domain of publisher without http://">
              <b-form-input
                type="text"
                v-model="publisher.domain"
                required
                placeholder="greatnews.com">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
              label="Publisher Categories"
              description="Categories of typical publisher content">
              <mulselect
                :options="cats"
                :values="publisher.cats"
                :limit="3">
              </mulselect>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
              label="Public description"
              description="Public description for demand partners">
              <b-form-textarea v-model="publisher.description"
                               rows="3"
                               placeholder="Let demand sources know what apps or sites you have to offer">
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-form-group
              label="Owned And Operated"
              description="Are all apps/sites under this account O&O?">
              <toggle-button
                v-model="publisher.is_owner"
                :sync="true"
                color="#2bd879">
              </toggle-button>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-btn @click="save()" variant="primary" class="mt-4">Save</b-btn>
      </b-form>
    </b-card>
  </div>
</template>

<script>
    import {PublisherApi} from '@/publisher/api'
    import iab from '@/assets/iab'
    import Mulselect from '@/components/Mulselect'
    import auth from '@/auth'
    import NewlineEditor from "../../components/NewlineEditor.vue";
    import StringListEditor from "../../components/StringListEditor.vue";

    export default {
        props: {
            cid: {required: false}
        },
        created() {
            PublisherApi.publisherDetails(this.companyId()).then((pub) => {
                if (!pub.blocked_adomains)
                  pub.blocked_adomains = []
                if (!pub.blocked_crids)
                  pub.blocked_crids = []
                if (pub.enabled == undefined)
                  pub.enabled = true;

                this.publisher = pub

                this.status = 'loaded'
            }).catch((errorCode) => {
                if(errorCode.message === 'ERR_NOT_EXIST') {
                    this.status = 'new'
                } else {
                    this.$notify.error('Unknown error')
                }
            })
        },
        data () {
            return {
                status: 'loading',
                isSuperAdmin: auth.isSuperAdmin(),
                publisher: {
                    company_id: this.companyId(),
                    cats: [],
                    enabled: true,
                    blocked_adomains: [],
                    advertible: false,
                    blocked_crids: [],
                    x15_proxy_fraction: 0,
                    auction_burl: true,
                    auction_win_beacon: true
                },
                is_owner: false,
                cats: iab,
            }
        },
        methods: {
            companyId() {
                return this.cid ? this.cid : auth.details().company_id
            },
            save() {
                PublisherApi.publisherSet(this.publisher).then((data) => {
                    this.$notify.success('Saved')
                    if (this.status === 'new') {
                        this.$router.push({ name: 'PublisherMediums', params: { cid: this.companyId() } })
                    } else {
                        this.$router.go(-1)
                    }
                }, (err) => {
                    this.$notify.error(err)
                })
            }
        },
        computed: {
            isAdmin() {
                return auth.isAdmin()
            },
            categories() {
                let groups = {} /* code: [ { iab1-2: 'label' } ] */

                for (let code in iab) {
                    if (code.indexOf('-') === -1) {
                        if (!groups[code]) {
                            groups[code] = []
                        }
                        continue
                    }
                    let parent = code.split('-')[0]
                    let group = groups[parent]
                    group.push({code: code, label: (code + ' ' + iab[code])})
                }

                let opts = []
                for (let parent in groups) {
                    let cats = groups[parent]
                    opts.push({group: parent, children: cats})
                }

                return opts
            }
        },
        components: {
          NewlineEditor,
          Mulselect,
          StringListEditor
        }
    }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/PublisherSettings.vue